import { useEffect, useState } from 'react'
import { Routes, Route, Navigate, Outlet, Link, NavLink, useLocation, useNavigate, useParams } from 'react-router-dom'
import { AuthProvider, useAuth } from '../context/AuthContext'
import { USING_MOCK } from '../services/api'
import { RESOURCES } from './resources'
import Logo from '../components/Logo'
import AdminLogin from './AdminLogin'
import AdminDashboard from './AdminDashboard'
import AdminResource from './AdminResource'
import AdminOrders from './AdminOrders'
import './Admin.css'

// goes to the previous page; falls back to the dashboard (or the website from the dashboard)
function BackButton() {
  const nav = useNavigate()
  const { pathname } = useLocation()
  const back = () => (window.history.state?.idx > 0 ? nav(-1) : nav(pathname === '/admin' ? '/' : '/admin'))
  return (
    <button type="button" className="adm__back" onClick={back} aria-label="Go back">
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </button>
  )
}

function Shell() {
  const { isAuthed, logout } = useAuth()
  const loc = useLocation()
  const [open, setOpen] = useState(false)

  // close the mobile menu after choosing a page
  useEffect(() => { setOpen(false) }, [loc.pathname])

  if (!isAuthed) return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />

  return (
    <div className="adm adm--layout">
      <div className="adm__top">
        <Link to="/admin" className="adm__logo" aria-label="iPOINT Admin home"><Logo /></Link>
        <button className="adm__menu" onClick={() => setOpen(true)} aria-expanded={open} aria-controls="adm-side">Menu</button>
      </div>

      <div className={`adm__scrim${open ? ' is-open' : ''}`} onClick={() => setOpen(false)} />

      <aside id="adm-side" className={`adm__side${open ? ' is-open' : ''}`}>
        <Link to="/admin" className="adm__brand" aria-label="iPOINT Admin home">
          <span className="adm__logo"><Logo /></span>
          <span className="adm__brandtag">Admin panel</span>
        </Link>
        <nav aria-label="Admin sections">
          <NavLink to="/admin" end>Dashboard</NavLink>
          <NavLink to="/admin/orders">Orders</NavLink>
          {Object.entries(RESOURCES).map(([n, r]) => (
            <NavLink key={n} to={`/admin/${n}`}>{r.label}</NavLink>
          ))}
        </nav>
        <div className="adm__side-foot">
          <a href="/" target="_blank" rel="noreferrer">View site</a>
          <button onClick={logout}>Log out</button>
        </div>
      </aside>

      <div className="adm__content">
        {USING_MOCK && <p className="adm__mock"></p>}
        <main className="adm__main"><BackButton /><Outlet /></main>
      </div>
    </div>
  )
}

function ResourcePage() {
  const { name } = useParams()
  return <AdminResource name={name} />
}

export default function AdminApp() {
  useEffect(() => {
    const m = document.createElement('meta')
    m.name = 'robots'
    m.content = 'noindex,nofollow'
    document.head.appendChild(m)
    return () => m.remove()
  }, [])

  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<Shell />}>
          <Route index element={<AdminDashboard />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path=":name" element={<ResourcePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  )
}